import React, { useState, useEffect } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
  useLocation,
  useNavigate,
} from "react-router-dom";
import Home from "./pages/Home";
import Login from "./pages/Login";
import Register from "./pages/Register";
import SplashScreen from "./pages/SplashScreen";
import "antd/dist/reset.css";
import { QueryClient, QueryClientProvider, useQuery } from "@tanstack/react-query";
import { App as CapacitorApp } from "@capacitor/app";
import { Capacitor } from "@capacitor/core";
import toast, { Toaster } from "react-hot-toast";
import { StatusBar, Style } from "@capacitor/status-bar";
import RCFetch from "./pages/RCFetch";
import FetchRCDetailsWithChallan from "./pages/FetchRCDetailsWithChallan";
import Challan from "./pages/Challan";
import Profile from "./pages/Profile";
import ForgotPassword from "./pages/ForgotPass";
import NETC from "./pages/NETC";
import DrivingLicense from "./pages/DrivingLicense";
import TermsAndConditions from "./pages/policy/TermsAndCond";
import ContactPage from "./pages/Contact";
import ShippingPolicy from "./pages/policy/ShippingPolicy";
import PrivacyPolicy from "./pages/policy/Privacy";
import CancellationRefundPolicy from "./pages/policy/CancellationRefundPolicy";
import Wallet from "./pages/Wallet";
import IncToken from "./pages/IncToken";
import ViewRCONLY from "./pages/ViewRCONLY";
import { backend_url } from "./LOCAL/VARIABLE";

const queryClient = new QueryClient();

const ProtectedRoute = ({ children }) => {
  const token = localStorage.getItem("token");
  return token ? children : <Navigate to="/login" />;
};
















// const AppWrapper = () => {







//   const location = useLocation();
//   const navigate = useNavigate();

 







// const fetchMe = async () => {
//   const token = localStorage.getItem("token");
//   const res = await fetch(`${backend_url}/api/user/me`, {
//     headers: {
//       "Content-Type": "application/json",
//       Authorization: `Bearer ${token || ""}`,
//     },
//   });
//   if (!res.ok) {
//     const err = await res.json().catch(() => ({}));
//     throw new Error(err.message || "Failed to fetch profile");
//   }
//   return res.json();
// };


//   const { data,refetch,   isError,
//     error,           isLoading } = useQuery({
//     queryKey: ["me"],
//     queryFn: fetchMe,
//     refetchOnWindowFocus: true,
//     retry: false,
    
//   });


 


//   useEffect(() => {
//     if (isError) {
//       console.warn("User fetch error:", error?.message);

//       // ❌ Don't redirect if user is already on auth pages
//       const currentPath = location.pathname;
//       const authPaths = ["/login", "/register", "/forgetpassword"];

//       if (!authPaths.includes(currentPath)) {
//         localStorage.removeItem("token");
//         navigate("/login");
//       }
//     }
//   }, [isError, error, navigate, location.pathname]);






//   const user = data?.user;  

//   // --- Optional: show loader while checking user ---
//   if (isLoading && localStorage.getItem("token")) {
//     return <SplashScreen/>
//   }


//   return (
//     <>
//       <Toaster position="top-right" />
//       <Routes>
//         <Route path="/login" element={<Login />} />
//         <Route path="/register" element={<Register />} />
//         <Route path="/fetchRCDetails" element={<RCFetch refetch={refetch} />} />
//         <Route
//           path="/FetchRCDetailsWithChallan"
//           element={<FetchRCDetailsWithChallan />}
//         />
//         <Route path="/forgetpassword" element={<ForgotPassword />} />
//         <Route path="/Profile" element={<Profile />} />
//         <Route path="/NETC" element={<NETC />} />
//         <Route path="/roadtext" element={<NETC  url={'roadtext'}   />} />
//         <Route path="/tempr" element={<NETC url={"tempr"}    />} />
//         <Route path="/dl"   element={<DrivingLicense   refetch={refetch}/>} />
//         <Route path="/Challan" element={<Challan />} />

//         <Route
//           path="/home"
//           element={
//             <ProtectedRoute>
//               <Home    user={user} />
//             </ProtectedRoute>
//           }
//         />
//         <Route
//           path="/wallet"
//           element={
//             <ProtectedRoute>
//               <Wallet  user={user}  />
//             </ProtectedRoute>
//           }
//         />
//         <Route path="/terms" element={<TermsAndConditions />} />
//         <Route path="/IncToken" element={<IncToken />} />
//         <Route path="/viewRC" element={<ViewRCONLY />} />
//         <Route path="/contact" element={<ContactPage />} />
//         <Route path="/shipping" element={<ShippingPolicy />} />
//         <Route path="/privacy" element={<PrivacyPolicy />} />
//         <Route path="/cancle" element={<CancellationRefundPolicy />} />
//         <Route
//           path="/"
//           element={
//             <Navigate to={localStorage.getItem("token") ? "/home" : "/login"} />
//           }
//         />
//       </Routes>
//     </>
//   );
// };




const AppWrapper = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const fetchMe = async () => {
    const token = localStorage.getItem("token");
    if (!token) {
      throw new Error("No token found");
    }
    
    const res = await fetch(`${backend_url}/api/user/me`, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });
    
    if (!res.ok) {
      const err = await res.json().catch(() => ({}));
      throw new Error(err.message || "Failed to fetch profile");
    }
    return res.json();
  };

  const { 
    data, 
    refetch, 
    isError, 
    error, 
    isLoading, 
     
  } = useQuery({
    queryKey: ["me"],
    queryFn: fetchMe,
    refetchOnWindowFocus: false, // Change to false to prevent unnecessary refetches
    retry: false,
    enabled: !!localStorage.getItem("token"), // Only run if token exists
  });

  useEffect(() => {
    const token = localStorage.getItem("token");
    const currentPath = location.pathname;
    const authPaths = ["/login", "/register", "/forgetpassword"];

    if (isError) {
      console.warn("User fetch error:", error?.message);
      
      // Only redirect if we have a token but it's invalid
      if (token && !authPaths.includes(currentPath)) {
        localStorage.removeItem("token");
        navigate("/login", { replace: true });
      }
    }

    // If no token and trying to access protected route, redirect to login
    if (!token && !authPaths.includes(currentPath)) {
      navigate("/login", { replace: true });
    }
  }, [isError, error, navigate, location.pathname]);

  const user = data?.user;
 
  // Show loader only when we have a token and are fetching user data
  if (isLoading  ) {
    return <SplashScreen />;
  }

  return (
    <>
      <Toaster position="top-right" />
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />
        <Route path="/fetchRCDetails" element={<RCFetch refetch={refetch} />} />
        <Route
          path="/FetchRCDetailsWithChallan"
          element={<FetchRCDetailsWithChallan />}
        />
        <Route path="/forgetpassword" element={<ForgotPassword />} />
        <Route path="/Profile" element={<Profile />} />
        <Route path="/NETC" element={<NETC />} />
        <Route path="/roadtext" element={<NETC url={'roadtext'} />} />
        <Route path="/tempr" element={<NETC url={"tempr"} />} />
        <Route path="/dl" element={<DrivingLicense refetch={refetch} />} />
        <Route path="/Challan" element={<Challan />} />

        <Route
          path="/home"
          element={
            <ProtectedRoute>
              <Home user={user} />
            </ProtectedRoute>
          }
        />
        <Route
          path="/wallet"
          element={
            <ProtectedRoute>
              <Wallet user={user} />
            </ProtectedRoute>
          }
        />
        <Route path="/terms" element={<TermsAndConditions />} />
        <Route path="/IncToken" element={<IncToken />} />
        <Route path="/viewRC" element={<ViewRCONLY />} />
        <Route path="/contact" element={<ContactPage />} />
        <Route path="/shipping" element={<ShippingPolicy />} />
        <Route path="/privacy" element={<PrivacyPolicy />} />
        <Route path="/cancle" element={<CancellationRefundPolicy />} />
        <Route
          path="/"
          element={
            <Navigate to={localStorage.getItem("token") ? "/home" : "/login"} replace />
          }
        />
      </Routes>
    </>
  );
};









function App() {
 

  return (
    <Router>
      <QueryClientProvider client={queryClient}>
        <AppWrapper />
      </QueryClientProvider>
    </Router>
  );
}

export default App;
